export default function () {
  return {
    tabDocument: {
      email: '',
      document: [],
      ordenes: [],
    },
    documentVisibleColumns: ['numero', 'operacion', 'serie', 'cliente_email', 'tipo_de_comprobante', 'sunat_transaction', 'fecha_de_emision', 'total', 'actions'],
    ordenVisibleColumns: ['status', 'created', 'amount', 'ramount', 'ramount_at', 'discount', 'rdiscount', 'price', 'rprice'],
  }
}
